/**
 * Pattern for action names and action input field (JSON schema property) names.
 *
 * Tightest of the providers we route to:
 *  - OpenAI tool name: ^[a-zA-Z0-9_-]{1,64}$
 *  - Anthropic input_schema property key: ^[a-zA-Z0-9_.-]{1,64}$
 *  - Vercel AI SDK tool name: ^[a-zA-Z0-9_-]{1,128}$
 *  - Google Gemini (OpenAPI 3.0 schema): identifier-like
 *
 * Anthropic rejects spaces in property keys with HTTP 400. We use a single
 * conservative pattern that satisfies all four.
 */
export const ACTION_NAME_PATTERN = /^[a-zA-Z0-9_-]{1,64}$/;
export const ACTION_NAME_MAX_LENGTH = 64;
const INVALID_CHAR_REGEX = /[^a-zA-Z0-9_-]/g;
const VALID_CHAR_REGEX = /^[a-zA-Z0-9_-]$/;
export const ACTION_NAME_ERROR = 'Only letters, numbers, underscores, and hyphens are allowed (max 64 characters)';
export const isValidActionName = (name) => ACTION_NAME_PATTERN.test(name);
/** Strips invalid characters and clamps to max length. Use to clean pasted input. */
export const stripInvalidActionNameChars = (input) => input.replace(/ /g, '_').replace(INVALID_CHAR_REGEX, '').slice(0, ACTION_NAME_MAX_LENGTH);
/** Returns true if a single keystroke (e.g. from KeyboardEvent.key) is allowed in the input. */
export const isValidActionNameChar = (key) => VALID_CHAR_REGEX.test(key);
/**
 * Walks a JSON-Schema-like shape and returns the first property key that fails
 * `isValidActionName`. Recurses through nested `properties` (object) and `items`
 * (array) so deeply-nested invalid keys are caught.
 */
export const findInvalidPropertyKey = (schema) => {
    if (!schema || typeof schema !== 'object')
        return undefined;
    const s = schema;
    if (s.properties) {
        for (const key of Object.keys(s.properties)) {
            if (!isValidActionName(key))
                return key;
            const nested = findInvalidPropertyKey(s.properties[key]);
            if (nested)
                return nested;
        }
    }
    if (s.items) {
        const nested = findInvalidPropertyKey(s.items);
        if (nested)
            return nested;
    }
    return undefined;
};
//# sourceMappingURL=name-validation.js.map